import { render } from "./AddCardNews.vue?vue&type=template&id=1e0eecca&scoped=true"
import script from "./AddCardNews.vue?vue&type=script&lang=js"
export * from "./AddCardNews.vue?vue&type=script&lang=js"

import "./AddCardNews.vue?vue&type=style&index=0&id=1e0eecca&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0eecca"]])

export default __exports__